import { render, staticRenderFns } from "./TankYou.vue?vue&type=template&id=79698432&scoped=true"
import script from "./TankYou.vue?vue&type=script&lang=js"
export * from "./TankYou.vue?vue&type=script&lang=js"
import style0 from "./TankYou.vue?vue&type=style&index=0&id=79698432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79698432",
  null
  
)

export default component.exports